import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Actions, ofActionCompleted, Select } from '@ngxs/store';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { Observable } from 'rxjs';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { AccountingExport } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DatePipe } from '@angular/common';
import { take } from 'rxjs/operators';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatDialog } from '@angular/material/dialog';
import { MatterAccountingDispatch } from '@state/matter/accounting/accounting.dispatch';
import { ExportLeap } from '@state/matter/accounting/accounting.actions';

@UntilDestroy()
@Component({
	selector: 'app-leap-export-modal',
	templateUrl: './leap-export-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LeapExportModalComponent implements OnInit {
	@Select(SelectedMatter.getAccountingExport)
	accountingExport$: Observable<AccountingExport>;

	@SelectSnapshot(SelectedMatter.id) matterId: string;

	public lastExportedAt = 'Not exported yet';
	public exporting = false;

	constructor(
		private analyticsService: AnalyticsService,
		private datePipe: DatePipe,
		private dialog: MatDialog,
		private matterAccountingDispatch: MatterAccountingDispatch,
		private actions$: Actions,
	) {}

	ngOnInit() {
		this.accountingExport$
			.pipe(untilDestroyed(this))
			.subscribe((accountingExport) => {
				if (accountingExport && accountingExport.lastExportedAt) {
					this.lastExportedAt = this.datePipe.transform(
						accountingExport.lastExportedAt,
						'medium',
					);
				}
			});
	}

	onSubmit() {
		this.exporting = true;
		this.analyticsService.logEvent(AnalyticsEvent.LEAP_SOA_EXPORT_CLICK);
		this.actions$.pipe(ofActionCompleted(ExportLeap), take(1)).subscribe(() => {
			this.dialog.closeAll();
			this.exporting = false;
		});

		this.matterAccountingDispatch.ExportLeap();
	}
}
